import React, { ReactNode } from "react";

interface SectionCardProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
}

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  children,
  className = "",
}) => {
  return (
    <div className={`demo-section mb-5 ${className}`}>
      <h2 className="mb-4">{title}</h2>
      {children}
    </div>
  );
};

export default SectionCard;
